<!--<div class="container-fluid">-->


   
  <form id="reviewform" [formGroup]="regForm"  (ngSubmit)="step18Submitted(regForm)">
  

   <h3 style="font-weight: bold;">{{'Step11-Review.TranslationSection.text1' | translate}}</h3>

   <div class="form-row">

     <div class="col-lg-2 col-sm-2 col-md-2">

     </div>

     <div class="col-lg-6 col-sm-6 col-md-6" style="text-align: left;">

   <!--<br/>Applicant Type: {{regForm.get('applicantType').get('initialapplicanttype').value}} -->
   <br/><b>{{'Step11-Review.TranslationSection.text2' | translate}}</b>: {{regForm.get('firstName').value}} 
   <br/><b>{{'Step11-Review.TranslationSection.text3' | translate}}</b>: {{regForm.get('lastName').value}} 
   <br/><b>{{'Step11-Review.TranslationSection.text4' | translate}}</b>: {{conForm.get('email').value}}
   <br/><b>{{'Step11-Review.TranslationSection.text5' | translate}}</b>: 
   
   {{
     
    regForm.get('priLanguage').value==1 ? 'English':
    regForm.get('priLanguage').value==2 ? 'Spanish':
    regForm.get('priLanguage').value==3 ? 'Chinese':
    regForm.get('priLanguage').value==4 ? 'Russian':
    regForm.get('priLanguage').value==5 ? 'Other':
    'NA'
  
  
  }}
   <br/><b>{{'Step11-Review.TranslationSection.text6' | translate}} </b>: 
   
   {{
     
    regForm.get('position').value==1 ? 'HHA':
    regForm.get('position').value==2 ? 'CNA':
    regForm.get('position').value==3 ? 'PCA':
    regForm.get('position').value==4 ? 'Companion':
    regForm.get('position').value==5 ? 'RN':
    regForm.get('position').value==6 ? 'LPN':
    regForm.get('position').value==7 ? 'NP':
    regForm.get('position').value==8 ? 'HHA':
    regForm.get('position').value==9 ? 'HCA':
    'NA'
  
  
  }} &nbsp;<b>({{'Step11-Review.TranslationSection.text7' | translate}})</b>
   <br/><b>{{'Step11-Review.TranslationSection.text8' | translate}}</b>: {{conForm.get('address').value}}
   <br/><b>{{'Step11-Review.TranslationSection.text9' | translate}}</b>: {{conForm.get('city').value}}
   <br/><b>{{'Step11-Review.TranslationSection.text10' | translate}}</b>: {{conForm.get('state').value}}
   <br/><b>{{'Step11-Review.TranslationSection.text11' | translate}}</b>: {{conForm.get('zip').value}}
   <br/>
   </div>

   <div class="col-lg-4 col-sm-4 col-md-4">

   </div>


 </div>



   <br/>



<!--////////////////////////////////////////////////////We're going to put the for loop in here to post to onbase-->







<button type="button" (click)="decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step11-Review.TranslationSection.text12' | translate}}</button>
   &nbsp;
   <!--<button type="submit" class="btn btn-primary" >Save and Continue &nbsp;
     <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button> -->  

     <button  type="submit"  id="submit" value="SUBMIT" class="btn btn-success" name="OBBtn_Yes" [disabled]='this.isfetching'>
      {{'Step11-Review.TranslationSection.text13' | translate}}    
     </button>



     <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step11-Review.TranslationSection.text14' | translate}}</i>
   



   
 </form>

<!--</div>-->
 
 

 
 
 
